import React from "react"
import axios from "axios"
import * as Sentry from "@sentry/browser"
import { Menu, Anchor } from "@mantine/core"
import { Button, Icon } from "@/components"

import urls from "app/static/frontend/imports/desktopPaths"
import accountsConstants from "app/static/frontend/accounts/accountsConstants"

import { useStyles } from "@/components/TopNavigation/components/Dropdown.styles"

export const UserActionsDropdown = ({ popdownIsOpen }) => {
    const { classes } = useStyles({
        loggedInAsUser: Boolean(Userdata.logged_in_as_user) || Boolean(Userdata.logged_in_as_user_from_regular_user),
        popdownIsOpen,
    })

    const canManageFeatureFlags = Userdata.logged_in_as_user || Userdata.is_quorum_employee || Userdata.is_demo_account

    const returnToAdminUser = async () => {
        try {
            window.swal(accountsConstants.returnToAdmin.start)
            await axios.post(`/admin/login/return_to_admin/`, {}, { params: [] })
            window.location.href = urls.allUsers
        } catch (error) {
            Sentry.captureException(error)
            window.swal(accountsConstants.returnToAdmin.fail)
        }
    }

    return (
        <Menu position="bottom-end">
            <Menu.Target>
                <Button variant="outline" className={classes.button}>
                    <Icon icon="user" className={classes.topBarIcon} ariaLabel="Access account options" />
                </Button>
            </Menu.Target>

            <Menu.Dropdown role="menu" className={classes.dropdown}>
                <div className={classes.email}>{Userdata.email}</div>
                <Menu.Divider className={classes.divider} />

                {(Userdata.logged_in_as_user || Userdata.logged_in_as_user_from_regular_user) && (
                    <Menu.Item className={classes.item} onClick={returnToAdminUser}>
                        <Icon icon="fast-backward" className={classes.icon} />
                        Go Back to Admin
                    </Menu.Item>
                )}

                {Userdata.is_staff && (
                    <>
                        <Menu.Item className={classes.item} component="a" href={urls.manageOrgs}>
                            <Icon icon="building" className={classes.icon} />
                            Manage Organizations
                        </Menu.Item>
                    </>
                )}

                {(Userdata.is_staff || (Userdata.admin_can_log_in_as_user && Userdata.is_admin)) && (
                    <Menu.Item className={classes.item} component="a" href={urls.allUsers}>
                        <Icon icon="globe-americas" className={classes.icon} />
                        Manage All Users
                    </Menu.Item>
                )}

                {canManageFeatureFlags && (
                    <Menu.Item className={classes.item} component="a" href={urls.featureflags}>
                        <Icon icon="flag-alt" className={classes.icon} />
                        Manage Feature Flags
                    </Menu.Item>
                )}

                <Menu.Item className={classes.item} component="a" href={urls.settings}>
                    <Icon icon="cog" className={classes.icon} />
                    Settings
                </Menu.Item>

                <Menu.Item className={classes.item} component="a" href={urls.files}>
                    <Icon icon="download" className={classes.icon} />
                    Downloads & Uploads
                </Menu.Item>

                <Menu.Divider />
                <Anchor href={urls.logout} className={classes.anchor}>
                    <Menu.Item className={classes.logout}>
                        <Icon icon="sign-out-alt" className={classes.logoutIcon} />
                        Logout
                    </Menu.Item>
                </Anchor>
            </Menu.Dropdown>
        </Menu>
    )
}
